import { Dayjs } from "dayjs"
import { ICommunicationsEmail } from "./communicationsEmail.type"
import { Status } from "@/types/Status"
import { isHTML } from "@/helpers/stringHelpers"

export class CommunicationsEmail implements ICommunicationsEmail {
  subject: string
  id: number
  dateDelivered: Dayjs
  opened: boolean
  htmlContent: string | null

  constructor(
    id: number,
    subject: string,
    dateDelivered: Dayjs,
    opened: boolean,
    htmlContent: string | null,
  ) {
    this.id = id
    this.dateDelivered = dateDelivered
    this.opened = opened
    this.subject = subject
    this.htmlContent = htmlContent
  }

  get status(): Status {
    return this.opened
      ? new Status("normal", "Opened")
      : new Status("caution", "Unread")
  }

  get html() {
    return this.htmlContent && isHTML(this.htmlContent)
      ? this.htmlContent
      : undefined
  }
  get htmlPath() {
    return this.htmlContent && !isHTML(this.htmlContent)
      ? this.htmlContent
      : undefined
  }
}
